// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BidDetailsCard_BidDetailsCard__pOT3i {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 12px;
  background-color: var(--white);
  border: 1px solid var(--border);
  margin-top: 16px;
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardHead__Jkl2G {
  display: flex;
  justify-content: space-between;
  align-items: start;
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardHead__Jkl2G h2 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardHead__Jkl2G img {
  width: 16px;
  height: 16px;
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardBody__2kSVs {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardBody__2kSVs .BidDetailsCard_BidDetailsSemiTitle__9nsjl {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--brand);
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardBody__2kSVs p {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardBody__2kSVs .BidDetailsCard_fileUploadedList__8QHbn {
  padding: 12px;
  width: 100%;
  justify-content: space-between;
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardBody__2kSVs .BidDetailsCard_fileUploadedList__8QHbn .BidDetailsCard_fileUploadedItem__Q4ei3 {
  display: flex;
  align-items: center;
  gap: 12px;
}
.BidDetailsCard_BidDetailsCard__pOT3i .BidDetailsCard_BidDetailsCardBody__2kSVs .BidDetailsCard_fileUploadedList__8QHbn span {
  color: var(--brand);
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/BidDetailsCard/BidDetailsCard.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;AACD;AACC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;AACF;AACE;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AACH;AAEE;EACC,WAAA;EACA,YAAA;AAAH;AAIC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIE;EACC,2BAAA;EACA,gBAAA;EACA,mBAAA;AAFH;AAKE;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAHH;AAME;EACC,aAAA;EACA,WAAA;EACA,8BAAA;AAJH;AAMG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAJJ;AAOG;EACC,mBAAA;EACA,SAAA;AALJ","sourcesContent":[".BidDetailsCard {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n\tpadding: 16px;\r\n\tborder-radius: 12px;\r\n\tbackground-color: var(--white);\r\n\tborder: 1px solid var(--border);\r\n\tmargin-top: 16px;\r\n\r\n\t.BidDetailsCardHead {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: start;\r\n\r\n\t\th2 {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.BidDetailsCardBody {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 4px;\r\n\r\n\t\t.BidDetailsSemiTitle {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 400;\r\n\t\t\tcolor: var(--brand);\r\n\t\t}\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\r\n\t\t.fileUploadedList {\r\n\t\t\tpadding: 12px;\r\n\t\t\twidth: 100%;\r\n\t\t\tjustify-content: space-between;\r\n\r\n\t\t\t.fileUploadedItem {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tcolor: var(--brand);\r\n\t\t\t\tflex: 1;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BidDetailsCard": `BidDetailsCard_BidDetailsCard__pOT3i`,
	"BidDetailsCardHead": `BidDetailsCard_BidDetailsCardHead__Jkl2G`,
	"BidDetailsCardBody": `BidDetailsCard_BidDetailsCardBody__2kSVs`,
	"BidDetailsSemiTitle": `BidDetailsCard_BidDetailsSemiTitle__9nsjl`,
	"fileUploadedList": `BidDetailsCard_fileUploadedList__8QHbn`,
	"fileUploadedItem": `BidDetailsCard_fileUploadedItem__Q4ei3`
};
export default ___CSS_LOADER_EXPORT___;
